import { PlanRecordKeyTypes } from '@constants/plans'
import { setLocalStorage } from '@helpers/storage'
import { CHECKOUT_DATA } from '@pages/Checkout/constants'
import PAYMENTS, { CheckoutRoutesTypes } from '@routes/path/payments'

export const setCheckoutData = ({
  selectedRecordKey,
  currentStep = PAYMENTS.CHECKOUT.PLANS
}: {
  selectedRecordKey?: PlanRecordKeyTypes
  currentStep?: CheckoutRoutesTypes
}) => {
  const prevState = JSON.parse(localStorage.getItem(CHECKOUT_DATA) || '{}')

  const data = {
    ...prevState,
    ...(selectedRecordKey && { selectedRecordKey }),
    ...(currentStep && { currentStep })
  }

  setLocalStorage(CHECKOUT_DATA, JSON.stringify(data))
}

interface CheckoutData {
  selectedRecordKey: PlanRecordKeyTypes | null
  currentStep: CheckoutRoutesTypes
}

export const getCheckoutData = (): CheckoutData => {
  const data = localStorage.getItem(CHECKOUT_DATA)

  if (!data) {
    return { selectedRecordKey: null, currentStep: PAYMENTS.CHECKOUT.PLANS }
  }

  return JSON.parse(data)
}
